import React from 'react';
import { BasePlanCard, PlanCardProps } from './BasePlanCard';

export const EssentialPlan = (props: PlanCardProps) => <BasePlanCard planType="essential" {...props} />;
